var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250.000000pt",
    height: "250.000000pt",
    viewBox: "0 0 250.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,250.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276 2276 c-80 -48 -75 25 -76 -1024 0 -897 1 -934 19 -970 11 -22 35 -46 59 -60 l40 -22 931 0 c895 0 933 1 969 19 22 11 46 35 60 59 l22 40 0 932 0 932 -22 40 c-14 24 -38 48 -60 59 -36 18 -74 19 -970 19 l-933 0 -39 -24z m946 -437 c318 -66 476 -434 306 -713 l-30 -49 194 -194 193 -193 -38 -37 -37 -38 -193 193 -194 194 -49 -30 c-279 -170 -647 -12 -713 306 -69 332 229 630 561 561z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037 1740 c-105 -27 -206 -112 -254 -215 -24 -52 -28 -72 -28 -150 0 -77 4 -99 28 -151 36 -77 113 -154 192 -191 52 -24 72 -28 150 -28 77 0 99 4 151 28 77 36 154 113 191 192 24 52 28 72 28 150 0 77 -4 99 -28 151 -36 77 -113 154 -190 189 -64 30 -175 41 -240 25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.0938cccb4ca3f30087bf13d3e8625f0c.svg";
export { ForwardRef as ReactComponent };